import {BaseDomainDataSource} from "../../../infrastructure/models/base-domain-data-source";
import {H2hResponseApiModel} from "./h2h.response-api-model";
import {GameH2hDomainModel} from "./game/game-h2h.domain-model";

export class H2hDataSource extends BaseDomainDataSource {
  apiModel: H2hResponseApiModel;
  game: GameH2hDomainModel;

  constructor(
    apiModel: H2hResponseApiModel,
    game: GameH2hDomainModel,
  ) {
    super(apiModel);

    this.game = game;
  }
}
